import script from "./AdminEvents.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminEvents.vue?vue&type=script&setup=true&lang=js"

import "./AdminEvents.vue?vue&type=style&index=0&id=47e83391&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47e83391"]])

export default __exports__